var map = {
	"./Zonk.mp3": 784,
	"./brunei.mp3": 785,
	"./cambodia.mp3": 786,
	"./china.mp3": 787,
	"./hongkong.mp3": 788,
	"./india.mp3": 789,
	"./indonesia.mp3": 790,
	"./japan.mp3": 791,
	"./korea.mp3": 792,
	"./laos.mp3": 793,
	"./macao.mp3": 794,
	"./malaysia.mp3": 795,
	"./philippines.mp3": 796,
	"./singapore.mp3": 797,
	"./taiwan.mp3": 798,
	"./thailand.mp3": 799,
	"./vietnam.mp3": 800,
	"./x1-2.mp3": 801,
	"./x1.mp3": 802,
	"./x2.mp3": 803
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 783;